import sharedNotificationSaga from 'library/src/notifications/redux/NotificationsSaga';
import {sharedReportsSagas} from 'library/src/report/redux/SharedReportSagas';
import sharedCommercialPackageSagas from 'modules/commercialPackages/redux/SharedCommercialPackagesSagas';
import sharedContractsSagas from 'modules/contracts/redux/SharedContractsSagas';
import {nitrogenSaga} from 'modules/nitrogen/sagas/NitrogenSaga';
import sharedOrganisationSagas from 'modules/organisations/redux/SharedOrganisationsSagas';
import {reportSaga} from 'modules/report/redux/ReportSaga';
import {subscriptionsSaga} from 'modules/subscriptions/saga/SubscriptionsSaga';
import {vegetationSagas} from 'modules/vegetation/sagas/VegetationSagas';
import {visioCropSagas} from 'modules/visio_crop/sagas/VisioCropSagas';
import {weatherSagas} from 'modules/weather/sagas/WeatherSagas';
import {all} from 'redux-saga/effects';
import {sharedProcessingSagas} from '../../library/src/processing/redux/SharedProcessingSagas';
import {authSagas} from '../../modules/auth/sagas/AuthSagas';
import {campaignsSagas} from '../../modules/campaigns/sagas/CampaignsSagas';
import {cropsSagas} from '../../modules/crops/sagas/CropsSagas';
import {fieldsSagas} from '../../modules/fields/sagas/FieldsSagas';
import {rotationSagas} from '../../modules/rotations/sagas/RotationSagas';
import {soilsSagas} from '../../modules/soils/sagas/SoilsSagas';
import {sysIrrigationSagas} from '../../modules/sysIrrigation/sagas/SysIrrigationSagas';
import {waterBalanceSagas} from '../../modules/waterBalance/sagas/WaterBalanceSagas';

export function* rootSagas() {
  yield all([
    authSagas(),
    fieldsSagas(),
    soilsSagas(),
    cropsSagas(),
    waterBalanceSagas(),
    sysIrrigationSagas(),
    campaignsSagas(),
    rotationSagas(),
    subscriptionsSaga(),
    nitrogenSaga(),
    weatherSagas(),
    reportSaga(),
    sharedReportsSagas(),
    vegetationSagas(),
    sharedNotificationSaga(),
    visioCropSagas(),
    sharedContractsSagas(),
    sharedOrganisationSagas(),
    sharedCommercialPackageSagas(),
    sharedProcessingSagas(),
  ]);
}
